import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { QuaternaryHeading } from 'components/Headings';
import { Small, Medium, LargeUp } from 'components/MediaQuery';
import Theme from 'styles/theme';

import InfoCardDesktop from './InfoCardDesktop';
import InfoCardMobile from './InfoCardMobile';

const InfoCarouselCard = ({ image, heading, subText, cardLabel, isInverted }) => (
  <div className={classNames('InfoCarouselCard', { 'InfoCarouselCard--inverted': isInverted })}>
    {cardLabel && (
      <div className="InfoCarouselCard__label">
        <QuaternaryHeading>{cardLabel}</QuaternaryHeading>
      </div>
    )}
    <Small>
      <InfoCardMobile image={image} heading={heading} subText={subText} />
    </Small>
    <Medium>
      <InfoCardMobile image={image} heading={heading} subText={subText} />
    </Medium>
    <LargeUp>
      <InfoCardDesktop image={image} heading={heading} subText={subText} />
    </LargeUp>
    <style jsx>
      {`
        .InfoCarouselCard {
          width: 100%;
          height: 100%;
          flex-direction: column;
          display: flex;
        }

        .InfoCarouselCard__label {
          margin-bottom: ${Theme.get('spacing') * 2}px;
          opacity: 0.5;
        }

        .InfoCarouselCard--inverted .InfoCarouselCard__label {
          opacity: 1;
        }
      `}
    </style>
  </div>
);

InfoCarouselCard.propTypes = {
  image: PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string }).isRequired,
  heading: PropTypes.string.isRequired,
  subText: PropTypes.shape({}).isRequired,
  cardLabel: PropTypes.string,
  isInverted: PropTypes.bool,
};

InfoCarouselCard.defaultProps = {
  cardLabel: '',
  isInverted: false,
};

export default InfoCarouselCard;
